import React, { useState, useEffect, useContext } from 'react';
import './NewOrganizationModal.css';
import Modal from '../Modal/Modal';
import NewCorporationDetail from './NewCorporationDetail';
import NewFacilityDetail from './NewFacilityDetail';
import UpdatedCorporationDetail from './UpdatedCorporationDetail';
import OrgActionPanel from './OrgActionPanel';
import UpdatedFacilityDetail from './UpdatedFacilityDetail';
import convenienceApi from '../../common/api/convenience';
import baseApi from '../../common/api/base';
import { AdminContext } from '../../contexts/AdminContext';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function NewOrganizationModal({ organization, hide, changeOrganization, addOrganization }) {
  const environmentContext = useContext(EnvironmentContext);
  const adminContext = useContext(AdminContext);
  const [updateStatus, setUpdateStatus] = useState('initial');
  const { hasToken } = environmentContext;

  if (logComponent('NewOrganizationModal')) { console.debug('NewOrganizationModal rendered'); }


  useEffect(() => {
    if (logComponent('NewOrganizationModal')) { console.debug('NewOrganizationModal useEffect [organization]'); }
    document.querySelector('.Modal').scrollTop = 0; // do this differently
  }, [organization])

  const acceptOrganization = () => {
    if (logComponent('NewOrganizationModal')) { console.debug('NewOrganizationModal acceptOrganization'); }
    if (!hasToken) return;

    setUpdateStatus('updating');

    convenienceApi.addMimiOrganization(organization)
      .then(
        newOrganization => {
          addOrganization(newOrganization);
          removeOrganizationFromDB(organization);
          adminContext.removeStagedOrganization(organization);
          setUpdateStatus('updated');
        },
        error => {
          setUpdateStatus('failed');
        }
      )
  }

  const removeOrganizationFromDB = (organization) => {
    if (logComponent('NewOrganizationModal')) { console.debug('NewOrganizationModal removeOrganizationFromDB'); }
    if (!hasToken) return;

    if (organization.stagedFacilityId) {
      baseApi.Staging.Facility.delete(organization.stagedFacilityId)
    } else if (organization.stagedCorporationId) {
      baseApi.Staging.Corporation.delete(organization.stagedCorporationId)
    }
  }

  return (
    <Modal isVisible={!!organization} hide={hide} remainOnBackdropClick={true}>
      <div className="New-Organization-Modal">
        {
          organization.uiData.type === 'corporation' &&
          (
            organization.uiData.isNew ?
              <NewCorporationDetail
                linkToFacility={changeOrganization}
                corporation={organization} /> :
              <UpdatedCorporationDetail
                linkToFacility={changeOrganization}
                corporation={organization} />
          )
        }
        {
          organization.uiData.type === 'facility' &&
          (
            organization.uiData.isNew ?
              <NewFacilityDetail
                linkToCorporation={changeOrganization}
                facility={organization} /> :
              <UpdatedFacilityDetail
                linkToCorporation={changeOrganization}
                facility={organization} />
          )
        }
        < OrgActionPanel
          organization={organization}
          updateStatus={updateStatus}
          cancel={hide}
          accept={acceptOrganization} />
      </div>
    </Modal>
  );
}